var map = {
	"./af.json": [
		"./locales/af.json",
		[
			"locales_af_json"
		]
	],
	"./ar.json": [
		"./locales/ar.json",
		[
			"locales_ar_json"
		]
	],
	"./bg.json": [
		"./locales/bg.json",
		[
			"locales_bg_json"
		]
	],
	"./bn.json": [
		"./locales/bn.json",
		[
			"locales_bn_json"
		]
	],
	"./ca.json": [
		"./locales/ca.json",
		[
			"locales_ca_json"
		]
	],
	"./cs.json": [
		"./locales/cs.json",
		[
			"locales_cs_json"
		]
	],
	"./cy.json": [
		"./locales/cy.json",
		[
			"locales_cy_json"
		]
	],
	"./da.json": [
		"./locales/da.json",
		[
			"locales_da_json"
		]
	],
	"./de.json": [
		"./locales/de.json",
		[
			"locales_de_json"
		]
	],
	"./el.json": [
		"./locales/el.json",
		[
			"locales_el_json"
		]
	],
	"./en.json": [
		"./locales/en.json",
		[
			"locales_en_json"
		]
	],
	"./en_AU.json": [
		"./locales/en_AU.json",
		[
			"locales_en_AU_json"
		]
	],
	"./en_GB.json": [
		"./locales/en_GB.json",
		[
			"locales_en_GB_json"
		]
	],
	"./eo.json": [
		"./locales/eo.json",
		[
			"locales_eo_json"
		]
	],
	"./es.json": [
		"./locales/es.json",
		[
			"locales_es_json"
		]
	],
	"./et.json": [
		"./locales/et.json",
		[
			"locales_et_json"
		]
	],
	"./eu.json": [
		"./locales/eu.json",
		[
			"locales_eu_json"
		]
	],
	"./fa.json": [
		"./locales/fa.json",
		[
			"locales_fa_json"
		]
	],
	"./fi.json": [
		"./locales/fi.json",
		[
			"locales_fi_json"
		]
	],
	"./fr.json": [
		"./locales/fr.json",
		[
			"locales_fr_json"
		]
	],
	"./fu.json": [
		"./locales/fu.json",
		[
			"locales_fu_json"
		]
	],
	"./gl.json": [
		"./locales/gl.json",
		[
			"locales_gl_json"
		]
	],
	"./he.json": [
		"./locales/he.json",
		[
			"locales_he_json"
		]
	],
	"./hi.json": [
		"./locales/hi.json",
		[
			"locales_hi_json"
		]
	],
	"./hr.json": [
		"./locales/hr.json",
		[
			"locales_hr_json"
		]
	],
	"./hu.json": [
		"./locales/hu.json",
		[
			"locales_hu_json"
		]
	],
	"./hy.json": [
		"./locales/hy.json",
		[
			"locales_hy_json"
		]
	],
	"./id.json": [
		"./locales/id.json",
		[
			"locales_id_json"
		]
	],
	"./it.json": [
		"./locales/it.json",
		[
			"locales_it_json"
		]
	],
	"./ja.json": [
		"./locales/ja.json",
		[
			"locales_ja_json"
		]
	],
	"./ka.json": [
		"./locales/ka.json",
		[
			"locales_ka_json"
		]
	],
	"./kn.json": [
		"./locales/kn.json",
		[
			"locales_kn_json"
		]
	],
	"./ko.json": [
		"./locales/ko.json",
		[
			"locales_ko_json"
		]
	],
	"./lt.json": [
		"./locales/lt.json",
		[
			"locales_lt_json"
		]
	],
	"./lv.json": [
		"./locales/lv.json",
		[
			"locales_lv_json"
		]
	],
	"./mi.json": [
		"./locales/mi.json",
		[
			"locales_mi_json"
		]
	],
	"./mk.json": [
		"./locales/mk.json",
		[
			"locales_mk_json"
		]
	],
	"./my.json": [
		"./locales/my.json",
		[
			"locales_my_json"
		]
	],
	"./nb_NO.json": [
		"./locales/nb_NO.json",
		[
			"locales_nb_NO_json"
		]
	],
	"./nl.json": [
		"./locales/nl.json",
		[
			"locales_nl_json"
		]
	],
	"./nn.json": [
		"./locales/nn.json",
		[
			"locales_nn_json"
		]
	],
	"./pl.json": [
		"./locales/pl.json",
		[
			"locales_pl_json"
		]
	],
	"./pt.json": [
		"./locales/pt.json",
		[
			"locales_pt_json"
		]
	],
	"./pt_BR.json": [
		"./locales/pt_BR.json",
		[
			"locales_pt_BR_json"
		]
	],
	"./rm.json": [
		"./locales/rm.json",
		[
			"locales_rm_json"
		]
	],
	"./ro.json": [
		"./locales/ro.json",
		[
			"locales_ro_json"
		]
	],
	"./ru.json": [
		"./locales/ru.json",
		[
			"locales_ru_json"
		]
	],
	"./sk.json": [
		"./locales/sk.json",
		[
			"locales_sk_json"
		]
	],
	"./sl.json": [
		"./locales/sl.json",
		[
			"locales_sl_json"
		]
	],
	"./sm.json": [
		"./locales/sm.json",
		[
			"locales_sm_json"
		]
	],
	"./sq.json": [
		"./locales/sq.json",
		[
			"locales_sq_json"
		]
	],
	"./sr.json": [
		"./locales/sr.json",
		[
			"locales_sr_json"
		]
	],
	"./sr@cyrl.json": [
		"./locales/sr@cyrl.json",
		[
			"locales_sr_cyrl_json"
		]
	],
	"./sr@latn.json": [
		"./locales/sr@latn.json",
		[
			"locales_sr_latn_json"
		]
	],
	"./sv.json": [
		"./locales/sv.json",
		[
			"locales_sv_json"
		]
	],
	"./ta.json": [
		"./locales/ta.json",
		[
			"locales_ta_json"
		]
	],
	"./te.json": [
		"./locales/te.json",
		[
			"locales_te_json"
		]
	],
	"./th.json": [
		"./locales/th.json",
		[
			"locales_th_json"
		]
	],
	"./to.json": [
		"./locales/to.json",
		[
			"locales_to_json"
		]
	],
	"./tr.json": [
		"./locales/tr.json",
		[
			"locales_tr_json"
		]
	],
	"./uk.json": [
		"./locales/uk.json",
		[
			"locales_uk_json"
		]
	],
	"./vi.json": [
		"./locales/vi.json",
		[
			"locales_vi_json"
		]
	],
	"./zh_CN.json": [
		"./locales/zh_CN.json",
		[
			"locales_zh_CN_json"
		]
	],
	"./zh_Hant.json": [
		"./locales/zh_Hant.json",
		[
			"locales_zh_Hant_json"
		]
	],
	"./zh_Hant_HK.json": [
		"./locales/zh_Hant_HK.json",
		[
			"locales_zh_Hant_HK_json"
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./locales lazy recursive ^\\.\\/.*\\.json$ referencedExports: default";
module.exports = webpackAsyncContext;